export default {
    currentStream: {},
    streams: [],
    messages: [],
}
